<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-center mb-3">
        {{ $t('PostProgram.ProgramEndedTitle') }}
      </h1>
      <div v-html="$t('PostProgram.ProgramEndedDesc')"></div>
      
      <a href="https://www.zukes.com/canada" target="_blank" class="btn btn-link mt-4 mb-4 px-5 py-2" style="font-weight: 700;">
        {{ $t('PostProgram.Button') }}
      </a>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
